import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../../components/bannerfrom";
import { Link } from "gatsby";

function Banner(props) {
  return (
    <div className="services_location_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="London">
                <h1>React Native App Development Company in UK</h1>
              </div>
              <p className="main_para">
                We take pride in our position as industry leaders, specializing
                in a comprehensive range of React Native development services.
                Our expert React Native developers build compatible
                cross-platform apps with the latest technology that stand out in
                the Android and iOS app stores. We can efficiently create a
                top-notch mobile app for your business using React Native
                development, saving you 30% of time and money.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
